import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { WorkplaceDTO } from '../types/workplace';
import { WorkplaceApiObject } from '../types/workplace-response';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceHttpService {
  private http = inject(HttpClient);

  public list$(companyID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces`;

    return this.http.get<WorkplaceApiObject>(url, { params });
  }

  public create$(companyID: number, payload: WorkplaceDTO) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces`;

    return this.http.post<WorkplaceApiObject>(url, payload);
  }

  public get$(companyID: number, workplaceID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces/${workplaceID}`;

    return this.http.get<WorkplaceApiObject>(url);
  }

  public update$(
    companyID: number,
    workplaceID: number,
    payload: WorkplaceDTO
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces/${workplaceID}`;

    return this.http.patch<WorkplaceApiObject>(url, payload);
  }

  public delete$(companyID: number, workplaceID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/workplaces/${workplaceID}`;

    return this.http.delete<null>(url);
  }
}
